"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var comparisonEngine_1 = require("../../features/comparison/comparisonEngine");
var metricValue_1 = require("../../features/metricValue");
var Accessor_1 = require("../../models/Accessor");
var TimeShiftCalculation_1 = require("./TimeShiftCalculation");
exports.RowShiftType = 'row-shift';
var isRowShiftCalculation = function (calc) {
    return calc !== undefined && calc.type === exports.RowShiftType;
};
exports.rowShiftTransformCreator = function (definition, name) { return function (sourceTable, windowedTable) { return exports.rowShiftTransform(definition, name, sourceTable, windowedTable); }; };
exports.rowShiftTransform = function (definition, name, sourceTable, windowedTable) {
    var _a, _b;
    var calculation = (_a = definition.schema[name]) === null || _a === void 0 ? void 0 : _a.calculation;
    if (!isRowShiftCalculation(calculation)) {
        throw new Error("Could not resolve RowShift calculation with name: " + name);
    }
    // For now, `RowShift` is implicitly coupled to the `timestamp` feature.
    // This is due to historical implementation reasons, and it should be relatively
    // straightforward to remove this limitation in the future.
    var timeColumnRef = (_b = calculation.source, (_b !== null && _b !== void 0 ? _b : metricValue_1.getTimestampFeature(definition.features)));
    var timestampAccessor = Accessor_1.accessorForReference(timeColumnRef);
    var outputFunc = TimeShiftCalculation_1.makeOutputFunc(definition, name, calculation);
    var comparisonPoints = comparisonEngine_1.generateMarkBasedComparison(sourceTable, windowedTable, calculation.amount, timestampAccessor, outputFunc);
    return comparisonEngine_1.interleaveComparisonPoints(windowedTable, comparisonPoints, timestampAccessor);
};
//# sourceMappingURL=RowShiftCalculation.js.map